<template>
  <div class="row">
    <div v-for="(service, index) in services" :key="index" class="col-12 col-md-6 row m-0 justify-content-center mt-5"
      style="height: 250px;">
      <div class="card" @click="GoAction(service.Flowno)">
        <img :src="$Img.url + 'SPA/' + service.ItemPicPath"></img>
      </div>
      <div class="col-12">
        <label class="spa-title">{{ service.Name }}</label>
      </div>
    </div>
    <div class="footer-stack"></div>
    <router-view></router-view>
  </div>
</template>

<script>
import checkLoginMixin from '@/mixins/checkLoginMixin';
export default {
  data() {
    return {
      services: [],
      IS_ON_FIRST_PAGE: true
    };
  },
  mixins: [checkLoginMixin],
  async mounted() {
    window.addEventListener("message", this.handleMessage);
    await this.init();
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleMessage);
  },
  methods: {
    handleMessage(event) {
      console.log("Received message event:", event);
      console.log("Message data:", event.data);

      if (event.data === "backButtonClick") {
        if (this.IS_ON_FIRST_PAGE) {
          parent.postMessage("goToHome", "*");
        } else {
          // Vue Router 返回上一頁
          this.$router.back();
        }
      }
    },
    async init() {
      await this.checktoken();
      const CheckUserInfo = await this.GetUserInfo();
      console.log(CheckUserInfo)
      if (CheckUserInfo == false) {
        //console.log('AAA')
        this.$parent.Msg('取得使用者資訊錯誤', '5', 'warning');
        return;
      }
      await this.GetSpaMenuA();
    },
    async GetSpaMenuA() {
      var post_data = {
        searchData: this.$Global.Base64Utils.utoa(JSON.stringify({
          ShopNO: this.$Global.Base64Utils.atou(this.$cookieFunc.getCookie('ShopNO')),
          //SuplNO: '20250103000001'
        })),
      };

      this.$axios({
        method: 'post',
        url: this.$URLJson.GetSpaMenuA,
        data: post_data,
      }).then(res => {
        var data = JSON.parse(this.$Global.Base64Utils.atou(res.data));
        this.services = data;
        console.log(data)
      }
      ).catch(function (error) {
        console.log(error);
      });

    },
    GoAction(Flowno) {
      localStorage.setItem('Flowno', Flowno);
      this.$router.push({ name: 'SpaItems' });
    }
  }
};
</script>

<style scoped>
.card {
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 1px 1px 1px 1px #CBB79A;
  height: 250px;
  width: 500px;
  cursor: pointer;
  border: none;
}

.card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.5rem;
}

.spa-title {
  margin: 0;
  color: #9B7F7F;
  font-size: 1.75rem;
}
</style>



// WEBPACK FOOTER //
// src/components/View/Spa/SpaReservedMain.vue